import { SERVER_MESSAGES_SET_TOKEN, SERVER_MESSAGES_LOGOUT } from '@/store/actions/serverMessages';

const TOKEN_KEY = 'server_messages_token';

const tokenProvider = {
  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  },
  getToken() {
    return localStorage.getItem(TOKEN_KEY) || '';
  },
  setToken(value) {
    localStorage.setItem(TOKEN_KEY, value);
  },
};

const initialState = {
  serverMessagesToken: tokenProvider.getToken(),
};

const getters = {
  serverMessagesToken: (state) => state.serverMessagesToken,
};

const actions = {
  [SERVER_MESSAGES_LOGOUT]: ({ commit }) => {
    commit(SERVER_MESSAGES_LOGOUT);
    tokenProvider.clearToken();
  },
  [SERVER_MESSAGES_SET_TOKEN]: ({ commit }, token) => {
    commit(SERVER_MESSAGES_SET_TOKEN, token);
    if (token) {
      tokenProvider.setToken(token);
    } else {
      tokenProvider.clearToken();
    }
  },
};

const mutations = {
  [SERVER_MESSAGES_LOGOUT]: (state) => {
    state.serverMessagesToken = '';
  },
  [SERVER_MESSAGES_SET_TOKEN]: (state, token) => {
    state.serverMessagesToken = token || '';
  },
};

export default () => ({
  state: initialState,
  getters,
  actions,
  mutations,
});
